module.exports = __webpack_public_path__ + "static/11-f49d37950b0e105629fbf4023c765cea.jpg";